module.exports = __webpack_public_path__ + "img/filledu_LOGO.af326899.png";